<template>
  <div>
    <div>
      <!-- 使用组件 -->
      <MemberInfo></MemberInfo>
    </div>
    <div class="header-centers">
        <div >
          <el-card class="NumberCardWidth">
            <div class="deal flex-between">
              <div class="card-text">
                <h3>客户等级变更历史</h3>
              </div>
              <div class="card-button">
                <el-button
                  class="push-button"
                  @click="NvagetToLookMenber"
                  icon="iconfont icon-fanhui"
                  plain
                  >返回基本信息</el-button
                >
              </div>
            </div>
            <div class="NumberTable">
              <!-- table列表 -->
              <Table
                 @TouchTheBottom="TouchTheBottom"
                :PagesData="paging"
                :tableData="list.tbody"
                :configTable="list.thead"
                :config="list"
              ></Table>
            </div>
          </el-card>
        </div>
        <!-- 右侧列表相关链接 -->
        <!-- 使用封装的组件 -->
        <div class="PagesContentRight">
          <RightCard></RightCard>
        </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import { GetQueryCustLvlChgLog } from "@/api/viewMemberModule";
import Table from "/src/components/NumberTable/index.vue";
import { getcpyNo } from "@/utils/auth";
export default {
  name: "centre",
  components: {
    Table: Table,
  },
  data() {
    return {
      paging: {
        page: 1,
        size: 50,
        total: 0,
        pages:2,
        Loading:true
      },
      list: {
        thead: [
          //设置表头
          {
            label: "",
            prop: "CopyIndex",
            width: 50,
          },
          {
            label: "变更时间",
            prop: "chgTimeStr",
            width: 200,
          },
          {
            label: "原等级",
            prop: "origLevelName"
          },
          {
            label: "新等级",
            prop: "newLevelName"
          },
          {
            label: "变更类型",
            prop: "chgKindText"
          },
          {
            label: "变更人员",
            prop: "chgUser"
          },
        ],
        tbody: [],
      },
    };
  },
  computed: {
    ...mapState({
      custID: (state) => state.user.custID,
    }),
  },
  created() {
    this.RGetQueryCustLvlChgLog();
  },
  methods: {
    ReturnCoupNameText(state) {
      let ReturnCoupNameText = "";
      switch (state) {
        case 1:
          ReturnCoupNameText = "销售升级";
          break;
        case 2:
          ReturnCoupNameText = "销售降级";
          break;
        case 3:
          ReturnCoupNameText = "年末降级";
          break;
        case 4:
          ReturnCoupNameText = "手工升级";
          break;
        case 5:
          ReturnCoupNameText = "手工降级";
          break;
        case 6:
          ReturnCoupNameText = "GF绑定会员升级";
          break;
        case 7:
          ReturnCoupNameText = "GF陪同购买升级";
          break;
        case 8:
          ReturnCoupNameText = "体系变更升级";
          break;
        case 9:
          ReturnCoupNameText = "合卡升级";
          break;
      }
      return ReturnCoupNameText;
    },
    RGetQueryCustLvlChgLog() {
      let data = require('qs').stringify({
        cpyNo: getcpyNo,
        custID: this.custID,
        pageSize: this.paging.size,
        pageNo: this.paging.page,
      });
      GetQueryCustLvlChgLog(data).then((res) => {
        if (res.success == true) {
          this.paging.total = res.data.total;
          this.paging.pages = res.data.pages;
          res.data.list.forEach((item, index) => {
            item.CopyIndex =
              (this.paging.page - 1) * this.paging.size + index + 1;
            item.chgKindText = this.ReturnCoupNameText(parseInt(item.chgKind));
          });
          this.list.tbody =this.list.tbody.concat(res.data.list);
        } else {
          this.$message.error(res.message);
        }
         this.paging.Loading = false
      });
    },
    TouchTheBottom() {
      this.paging.page++;
      this.RGetQueryCustLvlChgLog();
    },
    NvagetToLookMenber() {
      this.$router.push("/LookMember");
    },
  }
};
</script>
<style lang="scss" scoped>
.NumberCardWidth{
  width: 1265px;
}
.header-centers {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 10px;
}
.PagesContentRight {
  margin-left: 25px;
  height: 990px;
  display: flex;
  flex-direction: column;
  justify-self: flex-start;
  align-content: flex-start;
}
.NumberTable {
  margin-top: 40px;
}
.card-text {
  color: #a19b5a;
}
.push-button {
  background-color: #e9e7d3;
  border-radius: 7px;
  color: #a19b59;
}
</style>
